import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-refund-policy',
  templateUrl: './refund-policy.component.html',
  styleUrls: ['./refund-policy.component.scss'],
   encapsulation: ViewEncapsulation.None  // ✅ Make sure this line is here
})
export class RefundPolicyComponent implements OnInit {

  constructor(private titleService: Title, private metaService: Meta) { }

  ngOnInit(): void {
    // Set page title
    this.titleService.setTitle('Refund Policy | MALtech | Hassle-Free Returns & Refunds');

    // Set meta description
    this.metaService.updateTag({
      name: 'description',
      content: 'Read MALtech\'s Refund Policy. Learn about conditions for returns, refunds eligibility, processing times, and shipping information. Hassle-free refunds for unused products.'
    });

    // Set meta keywords
    this.metaService.updateTag({
      name: 'keywords',
      content: 'MALtech refund policy, return policy, product returns, refunds, business refund policy, return conditions, shipping refunds, return process'
    });
  }

}

